'use client';
import { PreferenceToggle } from './PreferenceToggle';
import { useProductUpdate, useSetProductUpdate } from './ProductUpdatesProvider';

export type UpdateToggleHandler = (updateKey: string, enabled: boolean) => Promise<boolean | void>;
/** Called after a toggle saved, with the saved value, so the app can switch the feature without reloading. */
export type UpdateChangeHandler = (updateKey: string, enabled: boolean) => void;

export function UpdateToggle({ updateKey, enabled, onToggle, onChange, label, onError, className }: {
  updateKey: string;
  enabled: boolean;
  onToggle: UpdateToggleHandler;
  onChange?: UpdateChangeHandler;
  label: string;
  onError?: (message: string) => void;
  className?: string;
}) {
  const setUpdate = useSetProductUpdate();
  const current = useProductUpdate(updateKey, enabled);
  return <PreferenceToggle enabled={current} onToggle={(value) => onToggle(updateKey, value)}
    onSaved={(value) => { setUpdate(updateKey, value); onChange?.(updateKey, value); }} label={label} onError={onError} className={className} />;
}
